<template>
	<div>
		<button class="lillan-header__button"
				v-bind:aria-label="context.translations.header_search"
				v-html="require('!raw-loader!../../images/header-search.svg').default"
				v-on:click="openModal">
		</button>

		<MountingPortal mountTo="body" name="source" append>
			<transition name="top">
				<div class="header-search-overlay" v-if="modalOpen" v-on:click.self="modalOpen = false">
					<div class="header-search-overlay__inner">
						<div class="container-fluid">
							<form action="/">
								<input type="text" ref="search" name="s" v-bind:placeholder="context.translations.header_search">
							</form>
						</div>
					</div>
				</div>
			</transition>
			<transition name="fade">
				<div class="lillan-menu-shade"
					 v-if="modalOpen"
				></div>
			</transition>
		</MountingPortal>
	</div>
</template>

<script>
	export default {
		props: ['context'],
		data: function () {
			return {
				modalOpen: false,
			}
		},
		methods: {
			openModal() {
				this.modalOpen = true;
				setTimeout(() => {
					this.$refs.search.focus();
				}, 0)
			}
		}
	}
</script>
